/**
 * The room's export for the render job — the .glb (5–20 MB) and the render
 * manifest — held in memory between Get Estimate (when the 3D view is still
 * there to export it) and the save (when the estimate has a guid to upload
 * it under). Never in React state or in the estimate's JSON: too big for
 * either. One at a time; the key pairs it with the estimate's preview.
 */

import type { RenderManifest } from '../../ui/room3d/sceneExport';

export interface RenderAsset {
  key: string;
  glb: ArrayBuffer;
  manifest: RenderManifest;
}

let held: RenderAsset | null = null;

export function holdRenderAsset(asset: RenderAsset): void {
  held = asset;
}

/** The asset for `key`, and it is no longer held; null when it is not the one held (or there is none). */
export function takeRenderAsset(key: string | undefined): RenderAsset | null {
  if (!key || !held || held.key !== key) return null;
  const asset = held;
  held = null;
  return asset;
}

/** Whether an asset is held for `key` (without taking it). */
export function hasRenderAsset(key: string | undefined): boolean {
  return !!key && !!held && held.key === key;
}
